import React, { lazy, Suspense} from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Loading from 'components/common/Loading';
import ScrollToTop from 'components/scrollTop';
//라우터목록
const LoginRouter = lazy(() => import('modules/routers/LoginRouter')); //로그인
const AdminRouter = lazy(() => import('modules/routers/AdminRouter')); //관리자
const MainRouter = lazy(() => import('modules/routers/MainRouter')); //메인화면
const CompanyRouter = lazy(() => import('modules/routers/CompanyRouter')); //회사소개
const InvestRouter = lazy(() => import('modules/routers/InvestRouter')); //투자정보
const PromotionRouter = lazy(() => import('modules/routers/PromotionRouter')); //홍보센터
const RecruitRouter = lazy(() => import('modules/routers/RecruitRouter')); //채용
const Error404 = lazy(() => import('components/error/Error404')); //에러404
const Error500 = lazy(() => import('components/error/Error500')); //에러500
//
const Routing = (props) => {
    // const userContext = useContext(UserContext);
    return (
        <BrowserRouter>
        <ScrollToTop/>
            <Suspense fallback={<Loading/>}>
                <Switch>
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/login`} component={props => <LoginRouter {...props} />}/>
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/main`} component={props => <MainRouter {...props} />}/>
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/webmaster`}  component={props => <AdminRouter {...props} />} />
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/company`}  component={props => <CompanyRouter {...props} />} />
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/invest`}  component={props => <InvestRouter {...props} />} />
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/promotion`}  component={props => <PromotionRouter {...props} />} />
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/recruit`}  component={props => <RecruitRouter {...props} />} />
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/404`} component={Error404}/>
                    <Route path={`/${process.env.REACT_APP_LANGUAGE}/500`} component={Error500}/>
                    <Redirect path="/" to={`/${process.env.REACT_APP_LANGUAGE}/main`} /> 
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}

export default Routing;